import { render, staticRenderFns } from "./CourseCalendarPage.vue?vue&type=template&id=a014d1fc"
import script from "./CourseCalendarPage.vue?vue&type=script&lang=js"
export * from "./CourseCalendarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports